export default __webpack_public_path__ + "static/media/Asset 11.01e8bd20.png";